module.exports = __webpack_public_path__ + "gs.svg?be91ab5cec857ad89839684a0f8171e9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gs.svg
// module id = 1016
// module chunks = 27